import React from 'react';

const DetailBox = ({ children }) => {
  return <div style={{ padding: '2rem' }}>{children}</div>;
};

export default DetailBox;
